module.exports = __webpack_public_path__ + "img/bluesky19.d4437681.jpg";